import { render, staticRenderFns } from "./f2a.vue?vue&type=template&id=1ccdfed4&"
import script from "./f2a.vue?vue&type=script&lang=js&"
export * from "./f2a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports